import qs from 'query-string';
import { getPageProps, localStorage } from '@kibt/krn-utils';
import { postAddressQueryApiV3 } from '@/common/api-for-address';
import { getEnv, getKrnDomain } from '../api';
import { getAddressAb } from '@/hooks/abTest/useAddressAb';

export async function goAddAddressWhenNoAddress(url: string) {
    if (!url.includes('krn-web/order-confirm')) return url;
    const { query } = qs.parseUrl(url);
    if (query.isFromAddressAddDone === '1') return url;

    const ab = await getAddressAb();
    const ifEnterKrnAddress = ab?.find((item) => item.key === 'if_krn_address')?.value;
    if (!ifEnterKrnAddress) return url;

    // 从地址添加页跳到提单页不作判断
    const ifGoAddressDirectly = !!ab.find((item) => item.key === 'address_filling_interaction_optimization')?.value;
    if (ifGoAddressDirectly) {
        // 需要catch住，万一接口挂了，不能影响跳转
        const res = await postAddressQueryApiV3(null).catch((e) => e);
        if (res?.data?.length === 0) {
            // 无地址，直接去添加地址
            const krnUrl = qs.stringify({
                bundleId: 'EcommAddress',
                componentName: 'EcommAddress',
                env: getEnv(),
            });
            await localStorage.setItem('goAddAddressWhenNoAddressTempQuery', JSON.stringify(query));
            return qs.stringifyUrl({
                url: `${getKrnDomain()}/krn-web/address`,
                query: {
                    krnFollowParams: 1,
                    env: getEnv(),
                    ...query,
                    // extParams: JSON.stringify(getExtParams()),
                    goOrderConfirmWhenDone: '1',
                    type: 'AddNew',
                    initialRouteName: 'AddressAdd',
                    hyId: 'kibt-fe-shop-c-krn',
                    __launch_options__: JSON.stringify({
                        topBarPosition: 'fixed',
                    }),
                    redirectUrl: krnUrl,
                    isDefault: 'TRUE',
                },
            });
        }
    }

    return url;
}

export async function parseAddressUrl(url: string) {
    if (!url.includes('shop/c/address') || url.includes('shop/c/address-half')) return url;
    const ab = await getAddressAb();
    const krnAddressAbItem = ab?.find((item) => item.key === 'if_krn_address');
    const ifEnterKrnAddress = krnAddressAbItem?.value;
    if (!ifEnterKrnAddress) {
        const h5Url = url + '&' + qs.stringify({ groupName: krnAddressAbItem?.groupName, experimentName: krnAddressAbItem?.experimentName });
        return h5Url;
    }

    const { query } = qs.parseUrl(url);
    const krnUrl = qs.stringify({
        bundleId: 'EcommAddress',
        componentName: 'EcommAddress',
        env: getEnv(),
    });
    const isGoAddPage = url.includes('shop/c/address/add');
    return qs.stringifyUrl({
        url: `${getKrnDomain()}/krn-web/address`,
        query: {
            krnFollowParams: 1,
            env: getEnv(),
            ...query,
            // extParams: JSON.stringify(getExtParams()),
            fromBundle: getPageProps().bundleId,
            groupName: krnAddressAbItem?.groupName,
            experimentName: krnAddressAbItem?.experimentName,
            source: getPageProps().bundleId,
            ...(isGoAddPage
                ? {
                      type: query.id ? 'update' : 'AddNew',
                  }
                : {}),
            initialRouteName: isGoAddPage ? 'AddressAdd' : 'AddressHome',
            hyId: 'kibt-fe-shop-c-krn',
            __launch_options__: JSON.stringify({
                topBarPosition: 'fixed',
            }),
            redirectUrl: krnUrl,
        },
    });
}
